<template>
    <div class="search" v-click-outside="hideSearchResults" v-on:focusin="expandSearch" v-on:focusout="contractSearch">
        <div class="search__spacer" v-bind:class="{'search__spacer--collapsed' : searchBoxExpanded}">
        </div>
        <div class="search__wrapper">
            <div ref="searchBar" class="search__box">
                <input type="text" v-model="searchText" v-on:keyup.enter="search" v-on:focusin="showSearchResults" autocomplete="Search"/>
                <i class="fas fa-search"></i>
            </div>
            <div v-if="showResults || showNoResults" class="search__results">
                <ul>
                    <template v-if="showResults">
                        <li v-for="(booking, index) in results" v-bind:key="index" v-on:click="showTrip(booking)" v-bind:class="{'text-cancelled': isBookingCancelled(booking), 'text-temporary' : isEnquiry || isBlockOut}">
        <!--                    <div class="search__results__result-arrival">-->
        <!--                        <div class="search__results__result-arrival__month">{{getMonth(booking.arrival)}}</div>-->
        <!--                        <div class="search__results__result-arrival__day">{{getDay(booking.arrival)}}</div>-->
        <!--                        <div class="search__results__result-arrival__year">{{getYear(booking.arrival)}}</div>-->
        <!--                    </div>-->
        <!--                    {{booking.bookedBy.firstName}}  {{booking.bookedBy.lastName}}-->

                            <i class="fas fa-bed"></i>
                            <div class="search__results__result">
                                <span class="search__results__result__guest">{{ booking.bookedBy.firstName}}  {{booking.bookedBy.lastName}}</span>
                                <span class="search__results__result__check-in">Check-in: <strong>{{getFriendlyDate(booking.arrival)}}</strong></span>
                            </div>
                        </li>
                    </template>
                    <li v-if="showNoResults" class="search__results__no-result"> No results found</li>
                </ul>
            </div>
        </div>

        <div v-if="showTripDetails">
            <TripDetails v-bind:booking="this.trip"></TripDetails>
        </div>
        <div v-if="showTaskDetails">
            <TaskDetails v-bind:task="this.task"></TaskDetails>
        </div>

    </div>
</template>

<script>
    import TripDetails from "../bookings/TripDetails";
    import TaskDetails from "../tasks/TaskDetails";
    import {store} from '../../store.js'
    import * as dayjs from 'dayjs'

    export default {
        name: "Search.vue",
        components: {TripDetails, TaskDetails},
        data: function () {
            return {
                searchBoxExpanded: false,
                searchText: "",
                loading: false,
                results: [],
                showResultsBox: false,
                showNoResultsAfterSearch: false,
                showTripDetails: false,
                showTaskDetails: false,
                trip: null,
                task: null,
            }
        },
        computed: {
            showResults: function () {
                return this.showResultsBox && this.results.length > 0;
            },
            showNoResults: function () {
                return this.showResultsBox && this.showNoResultsAfterSearch;
            }
        },
        methods: {
            startTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: "shepherd-popup",
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                tour.addStep({
                    id: "search-bar",
                    text: 'Use the <b>search bar</b> to find Bookings by a guest\'s last name or by  Booking ID',
                    attachTo: {element: this.$refs.searchBar, on: 'bottom'},
                    buttons: [
                        {
                            text: 'Next',
                            action: tour.complete
                        }
                    ]
                });

                tour.on("complete", () => {
                    this.$root.$emit("tour-search-complete")
                })

                tour.start();
            },
            expandSearch: function() {
                console.log("Expanding search box");
                this.searchBoxExpanded = true;
            },
            contractSearch: function() {
                console.log("Contracting search box");
                setTimeout(() => {
                    this.searchBoxExpanded = false;
                }, 500);
            },
            search: function () {
                console.log("Search... text: " + this.searchText);
                this.loading = true;
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/search?searchText=' + this.searchText;
                this.$http.get(url, {
                    withCredentials: true
                }).then(response => {
                    this.clearSearchResults();
                    this.results.push(...response.data);
                    this.showResultsBox = true;
                    if (this.results.length === 0) {
                        this.showNoResultsAfterSearch = true;
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
            clearSearchResults: function() {
                this.results.splice(0, this.results.length);
            },
            hideSearchResults: function () {
                this.showResultsBox = false;
                this.showNoResultsAfterSearch = false;
            },
            showSearchResults: function () {
                this.showResultsBox = true;
            },
            isEnquiry: function(booking) {
                const state = String(booking.state)
                return state === 'enquiry'
            },
            isBlockOut: function(booking) {
                const state = String(booking.state)
                return state === 'block-out'
            },
            isBookingCancelled: function(booking) {
                const state = String(booking.state)
                return state === 'cancelled'
            },
            getDay: function (date) {
                return dayjs(date).format("D");
            },
            getMonth: function (date) {
                return dayjs(date).format("MMM");
            },
            getYear: function (date) {
                return dayjs(date).format("YYYY");
            },
            getFriendlyDate(date) {
                return dayjs(date).format('D MMM YYYY');
            },
            showTrip: function (booking) {
                console.log("Showing trip");
                this.trip = booking;
                this.hideSearchResults();
                setTimeout(() => {
                    this.showTripDetails = true;
                }, 250);
            },
            hideTrip: function () {
                this.showTripDetails = false;
                this.trip = null;
            },
            showTask: function (task) {
                console.log("Showing task");
                console.log(task);
                this.task = task;
                this.showTaskDetails = true;
                this.hideSearchResults();
            },
            hideTask: function () {
                console.log("Hiding task");
                this.showTaskDetails = false;
                this.task = null;
            },
            taskUpdated: function (task) {
                if (this.task && this.task.reference === task.reference) {
                    console.log("task updated: " + task.reference);
                    Object.assign(this.task, task);
                }
            }
        },
        mounted() {
            this.$root.$on('tour-main-complete', this.startTour)

            this.$root.$on('selected-establishment', this.clearSearchResults);
            this.$root.$on('open-trip-details', this.showTrip);
            this.$root.$on('finished-viewing-trip-details', this.hideTrip);
            this.$root.$on('open-task-details', this.showTask);
            this.$root.$on('finished-viewing-task-details', this.hideTask);
            this.$root.$on('task-updated', this.taskUpdated);
        },
        beforeDestroy() {
            this.$root.$off('tour-main-complete', this.startTour)

            this.$root.$off('selected-establishment', this.clearSearchResults);
            this.$root.$off('open-trip-details', this.showTrip);
            this.$root.$off('finished-viewing-trip-details', this.hideTrip);
            this.$root.$off('open-task-details', this.showTask);
            this.$root.$off('finished-viewing-task-details', this.hideTask);
            this.$root.$off('task-updated', this.taskUpdated);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/search";
    @import "../../styles/pages/list-bookings";
</style>